<template>
    <div class="flex col gap-20 w-full column mt-40  border-box">
            <div class="subs-header font-size-20 bold text-left">
                Subscriptions
            </div> 
            <div class="subscriptions flex gap-20 wrap">
                <div class="section p-20 flex-1">
                    <div class="header flex justify-between align-center">
                        <div class="general-info flex column  align-start">
                            <div class="labels">
                                <div v-if="localUser.clientAccount.fiu_section_available" class="module-enabled">Enabled</div>
                                <div v-else class="module-disabled">Disabled</div>
                            </div>
                            <div class="name bold font-size-18 text-left ">
                                FIU Module
                            </div>
                            <div class="time-period">
                                {{ formatTimePeriod('FIU') }}
                            </div>
                        </div>

                        <div class="edit flex column align-start h-full">
                            <img src="@/assets/edit.svg" class="p-10 pointer" alt="edit" @click="openEditSettings('FIU')"/>
                        </div>
                    </div>
                    <div class="extra"></div>
                </div>
                <div class="section p-20 flex-1">
                    <div class="header flex justify-between align-center">
                        <div class="general-info flex column  align-start">
                            <div class="labels">
                                <div v-if="localUser.clientAccount.kyc_section_available" class="module-enabled">Enabled</div>
                                <div v-else class="module-disabled">Disabled</div>
                            </div>
                            <div class="name bold font-size-18 text-left">
                                KYC Module
                            </div>
                            <div class="time-period">                                
                                {{ formatTimePeriod('KYC') }}
                            </div>
                        </div>
                        <div class="edit flex column align-start h-full">
                            <img src="@/assets/edit.svg" class="p-10 pointer" alt="edit" @click="openEditSettings('KYC')"/>
                        </div>
                    </div>
                    <div class="extra"></div>
                </div>
                <div class="section p-20 flex-1">
                    <div class="header flex justify-between align-center">
                        <div class="general-info flex column  align-start">
                            <div class="labels">
                                <div v-if="localUser.clientAccount.sanctions_screening_section_available" class="module-enabled">Enabled</div>
                                <div v-else class="module-disabled">Disabled</div>
                            </div>
                            <div class="name bold font-size-18 text-left">
                                Sanction Screaning Module
                            </div>
                            <div class="time-period">
                                {{ formatTimePeriod('SS') }}
                            </div>
                        </div>

                        <div class="edit flex column align-start h-full">
                            <img src="@/assets/edit.svg" class="p-10 pointer" alt="edit" @click="openEditSettings('SS')"/>
                        </div>
                    </div>
                    <div class="extra"></div>
                </div>
                <div class="section p-20 flex-1">
                    <div class="header flex justify-between align-center">
                        <div class="general-info flex column  align-start">
                            <div class="labels">
                                <div v-if="localUser.clientAccount.due_diligence_section_available" class="module-enabled">Enabled</div>
                                <div v-else class="module-disabled">Disabled</div>
                            </div>
                            <div class="name bold font-size-18 text-left">
                                Due Diligence Module
                            </div>
                            <div class="time-period">
                                {{ formatTimePeriod('DD') }}
                            </div>
                        </div>

                        <div class="edit flex column align-start h-full">
                            <img src="@/assets/edit.svg" class="p-10 pointer" alt="edit" @click="openEditSettings('DD')"/>
                        </div>
                    </div>
                    <div class="extra"></div>
                </div>
            </div>
            <PopupCover v-if="showPopup" @close="showPopup = false">
            <PopupBody @close="showPopup = false" style="width: 500px; margin: auto;">
                <template #header>Edit Access, {{sectionMap[showPopup]}} Module</template>
                <template #body>
                    <div class="input-area flex column gap-20" >
                        <div class="flex gap-20">
                            <InpComponent
                                :noMargin="true"
                                class="flex-1"
                                label="Available From"
                                type="date"
                                :key_ref="getSectionDateKey(null, 'start_date')"
                                :value="localUser.clientAccount[getSectionDateKey(null, 'start_date')] ? new Date(localUser.clientAccount[getSectionDateKey(null, 'start_date')]).toISOString().substr(0, 10) : ''"
                                @inputChange="inputChangeFunc"
                            />
                            <InpComponent
                                :noMargin="true"
                                class="flex-1"
                                label="Available To"
                                type="date"
                                :key_ref="getSectionDateKey(null, 'end_date')"
                                :value="localUser.clientAccount[getSectionDateKey(null, 'end_date')] ? new Date(localUser.clientAccount[getSectionDateKey(null, 'end_date')]).toISOString().substr(0, 10) : ''"
                                @inputChange="inputChangeFunc"
                            />
                        </div>
                        <Toggle
                            :disabled="reviewMode"
                            :value="localUser.clientAccount[getSectionDateKey(null, 'available')]"
                            :options="[
                                { label: 'Enabled', value: true },
                                { label: 'Disabled', value: false },
                            ]"
                            @change="(val) => inputChange(getSectionDateKey(null, 'available'), val)"
                            :label="'Status'"
                        />  
                        <Toggle
                            :disabled="reviewMode"
                            :value="localUser.clientAccount[getSectionDateKey(null, 'billed')]"
                            :options="[
                                { label: 'Enabled', value: true },
                                { label: 'Disabled', value: false },
                            ]"
                            @change="(val) => inputChange(getSectionDateKey(null, 'billed'), val)"
                            :label="'Billing'"
                        />  
                        <div v-if="showPopup == 'FIU'" class="flex column gap-20 bg-white p-20 border-rounded-gray">
                            <h3 class="m-0 text-left mb-10">Template Access</h3>
                            <div class="fiu-templates flex column gap-10">
                            <Toggle v-for="template in localUser.templatesData"
                                :disabled="reviewMode"
                                :value="template.enabled"
                                :options="[
                                    { label: 'Enabled', value: true },
                                    { label: 'Disabled', value: false },
                                ]"
                                @change="(val) => setAccess(template, val)"
                                :label="`Access to ${template.type} template`"
                            /> 
                            </div>
                        </div>
                        <div class="button-section flex gap-10 mt-40">
                            <button class="button transparent" @click="showPopup = false">Cancel</button>
                            <button class="button" @click="saveChanges()">Save</button>
                        </div>
                    </div>
                </template>
            </PopupBody>

        </PopupCover>
        </div>
</template>

<script setup>
import PopupCover from '@/components/PopupCover.vue';
import PopupBody from '@/components/PopupBody.vue';
import InpComponent from '@/components/InpComponent.vue'
import Toggle from '@/elements/Toggle.vue'
import { computed, ref } from 'vue'
import store from '../store';
import BO_API from '../api/bo_api.js'


const options = { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };

const localUser = computed(() => store.state.adminPannelUser);
const showPopup = ref(null);

const sectionMap = {
    'FIU': 'FIU',
    'KYC': 'KYC',
    'SS': 'Sanction Screening',
    'DD': 'Due Diligence'
}

function openEditSettings(moduleName){
    showPopup.value = moduleName;
}

function formatTimePeriod(section) {

    const startField = getSectionDateKey(section, 'start_date');
    const endField = getSectionDateKey(section, 'end_date');

    const start = localUser.value.clientAccount[startField];
    const end = localUser.value.clientAccount[endField];
    if (start && end) {
        const startDate = new Date(start);
        const endDate = new Date(end);
        const now = new Date();
        let status = '';

        if (endDate < now) {
            status = ' (Expired)';
        } else if ((endDate - now) / (1000 * 60 * 60 * 24) <= 7) {
            status = ' (Ending Soon)';
        }

        return `${startDate.toLocaleDateString('en-GB', options)} - ${endDate.toLocaleDateString('en-GB', options)}${status}`;
    } else {
        return 'No access period set';
    }
}

function getSectionDateKey(section, input_type){
    let sectionVal = section || showPopup.value; 

    const section_prefix = {
        'FIU': 'fiu_section',
        'KYC': 'kyc_section',
        'SS': 'sanctions_screening_section',
        'DD': 'due_diligence_section'
    }[sectionVal]
    return `${section_prefix}_${input_type}`;
}

function inputChangeFunc(event) {
    const event_type = event[0];
    const event_value = event[1];
    localUser.value.clientAccount[event_type] = event_value; 
}
function inputChange(key, value) {
    localUser.value.clientAccount[key] = value;
}
async function setAccess(template, value) {
    // const template = localUser.value.templatesData.find(t => t.type === showPopup.value);

    const result = await BO_API.setTemplateAccess(localUser.value.user.account_id, template.type, value);

    if (result.status == 'success') {
        template.enabled = value;
        store.dispatch('addNotification', {
            text: `Access to ${template.type} template ${value ? 'enabled' : 'disabled'} successfully`,
            type: 'success'
        })
    }
}
async function saveChanges (){
    const response = await BO_API.updateClientAccount(localUser.value.user.account_id ,localUser.value.clientAccount);
    if (response.status == 'success') {
        store.state.adminPannelUser.clientAccount = response.clientAccount;
        store.dispatch('addNotification', {
            text: 'Subscription updated successfully',
            type: 'success'
        })  
        showPopup.value = false;
    } else {
        store.dispatch('addNotification', {
            text: response.error || 'Error updating subscription',
            type: 'error'
        })  
    }
}
</script> 



<style scoped lang="scss">

.section {
    background: white;
    border: 1px solid var(--border-color);
    border-radius: 5px;
    min-width: 400px;
}
.labels {
    margin-bottom: 10px;
}
.module-enabled {
    background-color: rgb(136 249 180);
    color: rgb(0 109 64);
    font-size: 12px;
    padding: 2px 4px;
    border-radius: 4px; 
    font-weight: bold;
}
.module-disabled {
    background-color: rgb(246 246 252);
    color: rgb(195 198 207);
    font-size: 12px;
    padding: 2px 4px;
    border-radius: 4px; 
    font-weight: bold;
}
.time-period {
    color: gray
}
.vat-input {
    background-color: white;
    padding: 20px;
    border-radius: 10px;
    border: 1px solid var(--border-color);
    width: fit-content;
}
.fiu-templates {
    max-height: 40vh;
    overflow: auto;
}
</style>